import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {PageEventCursorInf} from '../../classes/common/table/page-event-cursor';


@Component({
  selector: 'cursor-paginator',
  templateUrl: './cursor-paginator.component.html',
  styleUrls: ['./cursor-paginator.component.scss']
})
export class CursorPaginatorComponent implements OnInit {

  @Input() pageIndex: number;
  @Output() firstPage = new EventEmitter<number>();
  @Output() previousPage = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();
  @Output() numberOfPageChanged = new EventEmitter<number>();
  @Input() pageSizeOptions: number[];
  @Input() pageSize: number;
  @Output() cursorPageChanged = new EventEmitter<PageEventCursorInf>();
  @Input() pageEventCursor: PageEventCursorInf;
  direction: string;
  currentPageBefore?: string;
  currentPageAfter?: string;
  currentPageDirection?: string;


  constructor() { }

  ngOnInit(): void {
    this.pageIndex = 1;
  }

  pageChanged(): void {
    const pageEventCursor = {
      page: this.pageIndex,
      pageSize: this.pageSize,
      before: this.pageEventCursor.before,
      after: this.pageEventCursor.after,
      direction: this.direction,
      currentPageBefore: this.pageEventCursor.before,
      currentPageAfter: this.pageEventCursor.after,
      currentPageDirection: this.direction
    };
    this.cursorPageChanged.emit(pageEventCursor);
  }

  defaultCursor(): void {
    this.pageIndex = 1;
    this.pageEventCursor.before = null;
    this.pageEventCursor.after = null;
    this.direction = 'before';
  }

  moveFirstPage(): void {
    this.defaultCursor();
    this.pageChanged();
  }

  movePreviousPage(): void {
    this.direction = 'before';
    this.pageIndex -= 1;
    this.pageChanged();
  }

  moveNextPage() {
    this.direction = "after";
    this.pageIndex += 1;
    this.pageChanged();
  }

  changePageSize(value) {
    this.pageSize = value;
    this.defaultCursor();
    this.pageChanged();
  }

  isFirstPage(): boolean {
     if(this.pageIndex === 1) {
       return true;
     } else {
       return false;
     }

  }

  isLastPage() {
    if('' + this.pageEventCursor.after === '-1')
      return true;
    else
      return false;
  }
}
